import { get } from 'lodash-es';
import { isCarMax } from 'site-modules/shared/utils/dealer-details-utils';
import { isCapOneProvider } from 'site-modules/shared/utils/financing/financing';
import { FINANCING_CAF_ADHESION_PANEL_CREATIVE_ID } from 'site-modules/shared/constants/financing/financing-constants';

export const getDataTrackingParent = ({ vinData, ted6504Recipe, showCapOneButton, isCapOneIneligible }) => {
  const dealer = get(vinData, 'dealerInfo.displayInfo.parentDealershipName');
  const isTED6504Enabled = ['chal-1', 'chal-2'].includes(ted6504Recipe) && isCarMax(dealer);

  if (isTED6504Enabled) {
    return FINANCING_CAF_ADHESION_PANEL_CREATIVE_ID;
  }

  const BASE_TRACKING = 'panel_email_form';

  if (showCapOneButton) {
    const matchStatus = isCapOneProvider(vinData) ? 'matched' : 'unmatched';
    const eligibilitySuffix = isCapOneIneligible ? '-ineligible' : '';
    return `${BASE_TRACKING}_${matchStatus}-vin${eligibilitySuffix}`;
  }

  return BASE_TRACKING;
};
